import { render, staticRenderFns } from "./TrainingSample.vue?vue&type=template&id=3218d1d8&"
import script from "./TrainingSample.vue?vue&type=script&lang=ts&"
export * from "./TrainingSample.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports